<template>
  <div class="background" ref="stickyelement">
    <HorizontalScrollContainer>
      <div class="item"><span class="f16-l19-m d-inline-block">{{barInfo.title}}</span></div>
      <div class="item pointer" v-for="(category, idx) in categories" :key="category.text" @click="sctollToCategory(category.category_id)">
        <span class="w-auto f16-l19-m" :style="category.text == 'מיוחד לחג' ? 'color:yellow' : '' " :class="moreClass(idx)">{{category.text}}</span>
      </div>
    </HorizontalScrollContainer>
  </div>
</template>
<script>
import HorizontalScrollContainer from "@/components/generic/HorizontalScrollContainer.vue";
export default {
  components: {
    HorizontalScrollContainer
  },
  props: {
    categories: Object,
    barInfo: Object
  },
  data() {
    return {
      stickyoffset: 0
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    const el = this.$refs["stickyelement"];
    this.stickyoffset = el.offsetTop + (this.$isDesktop() ? -101 : 0);
    el.style.left = el.offsetLeft + "px";
    el.style.width = el.clientWidth + "px";
  },
  unmounted() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      const stickyelement = this.$refs["stickyelement"];
      if (window.pageYOffset >= this.stickyoffset) {
        stickyelement.classList.add("sticky")
      } else {
        stickyelement.classList.remove("sticky");
      }
    },
    async sctollToCategory(categoryId) {
      const stickyelement = this.$refs["stickyelement"];
      const stickyMode = stickyelement.classList.contains("sticky");
      const el = document.getElementById('category_' + categoryId);
      const desktopOffset = this.$isDesktop() ? -120 : -50;
      if (el) {
        const y = el.getBoundingClientRect().top + window.pageYOffset - 130;
        await this.$nextTick();
        if (!stickyMode) {
          window.scrollTo({top: y - 45 + desktopOffset, behavior: 'smooth'});
        } else {
          window.scrollTo({top: y + desktopOffset, behavior: 'smooth'});
        }
      }
    },
    moreClass(idx) {
      if (idx == this.categories.length - 1) {
        return '';
      }
      return 'link';
    }
  }
}
</script>
<style scoped>
.sticky {
  position: fixed;
  top: 0;
  z-index: 1000;
}

@media (min-width: 1200px) {
  .sticky {
    top: 101px;
  }
}

.background {
  /* background: linear-gradient(270deg, rgba(56, 56, 59, 0) 0%, #38383b 100%); */
  background: #38383b;
  height: 53px;
  color: white;
  padding-left: 20px;
  padding-right: 20px;
  overflow: hidden;
  align-self: flex-start;
}

.item {
  display: inline-block;
  vertical-align: middle;
  line-height: 53px;
  padding: 0 5px;
}

.link {
  color: white;
  text-decoration: none;
  border-left: 1px solid #4e4e4f;
  padding-left: 10px;
  line-height: 21px;
  font-size: 16px;
  cursor: pointer;
}
</style>